<template>
  <div class="background-image">
    <v-toolbar flat absolute color="transparent" v-if="hasBackButton">
      <v-btn icon @click="goBack">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </v-toolbar>
    <div class="background-image-opacity">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasBackButton: {
      type: Boolean,
      default: false
    },
    backRoute: String
  },
  methods: {
    goBack() {
      if (this.backRoute) {
        this.$router.push({
          path: this.backRoute
        })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.background-image {
  background-image: url('../../assets/background.png');
  background-size: cover;
  width: 100%;
  height: 100%;
  background-position: center;

  .background-image-opacity {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
  }

  &.login {
    background-image: url('../../assets/login-background.jpg');
    background-position: 35%;
  }
}
</style>
